import React, { Component } from 'react';
import { connect } from 'react-redux';
import API from 'helpers/API';
import {
  shipmentFilterNameGroupTitle,
  shipmentFilterSelectStatesTitle,
  shipmentFilterShipmentTypeTitle,
  shipmentFilterShipmentTagsTitle,
  shipmentFilterExpiryTitle,
  shipmentFilterSelectIntegrationsTitle,
  shipmentFilterRestrictTriggerTitle,
  shipmentFilterSmartFilterTitle,
} from 'constants/titles';
import { isNavigationValid } from 'helpers/navigationValidators';
import MultiPageForm from 'components/MultiPageForm';
import {
  createShipmentFilter,
  updateShipmentFilter,
} from 'actions/shipmentFiltersActions';
import { closeSpinner, showSpinner } from 'actions';
import NameGroup from './ShipmentFilterForm/NameGroup';
import ShipmentStates from './ShipmentFilterForm/ShipmentStates';
import ShipmentType from './ShipmentFilterForm/ShipmentType';
import ShipmentTags from './ShipmentFilterForm/ShipmentTags';
import ShipmentFilterExpiry from './ShipmentFilterForm/ShipmentFilterExpiry';
import CarrierIntegrations from './ShipmentFilterForm/CarrierIntegrations';
import RestrictTrigger from './ShipmentFilterForm/RestrictTrigger';
import SmartFilter from './ShipmentFilterForm/SmartFilter';
import ShipmentFilterContext from './ShipmentFiltersContext';

class ShipmentFilterForm extends Component {
  static contextType = ShipmentFilterContext;

  constructor(props) {
    super(props);

    this.initialState = {
      name: '',
      carrier_integrations: [],
      states: [],
      calculated_events: [],
      custom_event_types: [],
      shipment_types: [],
      tags: [],
      is_carrier_state_filter_enabled: false,
      shipmentFilterExpiryMinutes: null,
      single_trigger_per_shipment_group: false,
      single_trigger_grouping_metakey: null,
      single_trigger_timespan_in_minutes: 0,
      smartFilterWaitType: '',
      smartFilterWaitTimeMinutes: null,
      smartFilterPriority: null,
      smartFilterTimeWindowTimezone: 'Europe/London', // This is hardcoded for now, can be changed later, see Smart Filter Processor for allowed values
      smartFilterTimeWindowEarlyHour: null,
      smartFilterTimeWindowLateHour: null,
    };

    if (this.props.initialData) {
      this.initialState = {
        id: this.props.initialData.id,
        carrier_integrations: this.props.initialData.carrier_integrations,
        name: this.props.initialData.name,
        states: this.props.initialData.states,
        calculated_events: this.props.initialData.calculated_events || [],
        custom_event_types: this.props.initialData.custom_event_types || [],
        shipment_types: this.props.initialData.shipment_types || [],
        tags: this.props.initialData.tags || [],
        is_carrier_state_filter_enabled: this.props.initialData.is_carrier_state_filter_enabled,
        shipmentFilterExpiryMinutes: this.props.initialData.shipmentFilterExpiryMinutes || null,
        single_trigger_per_shipment_group: this.props.initialData.single_trigger_per_shipment_group || false,
        single_trigger_grouping_metakey: this.props.initialData.single_trigger_grouping_metakey || null,
        single_trigger_timespan_in_minutes: this.props.initialData.single_trigger_timespan_in_minutes || 0,
        smartFilterWaitType: this.props.initialData.smartFilterWaitType || '',
        smartFilterWaitTimeMinutes: this.props.initialData.smartFilterWaitTimeMinutes || null,
        smartFilterPriority: this.props.initialData.smartFilterPriority || null,
        smartFilterTimeWindowTimezone: 'Europe/London',
        smartFilterTimeWindowEarlyHour: this.props.initialData.smartFilterTimeWindowEarlyHour || null,
        smartFilterTimeWindowLateHour: this.props.initialData.smartFilterTimeWindowLateHour || null,
      };
      this.props.setSummaryData(this.initialState);
    }

    this.navigationStepValidators = [
      () => this.state.formData.name && this.state.formData.name.length > 0, // Name step validation
      () => true, // Carrier integration step validation
      () => this.shipmentStatesStepValid(),
      () => this.state.formData.shipment_types && this.state.formData.shipment_types.length > 0, // Shipment type step validation
      () => true, // Shipment tags step validation
      () => true, // Expiry step validation
      () => true, // Shipment webhook step validation
      () => true, // Smart filter step validation
    ];

    this.state = {
      formData: {
        ...this.initialState,
      },
      page: 0,
      supportedStates: null,
      isCarrierStateFilterDirty: this.props.initialData != null,
    };

    this.prevCarrierIntegrations = null;
  }

  applyCarrierStateFilter =
    () => this.setState(prev => (
      {
        ...prev,
        formData: {
          ...prev.formData,
          is_carrier_state_filter_enabled: !prev.formData.is_carrier_state_filter_enabled,
          states: prev.formData.states.filter(x => prev.supportedStates.find(y => y.state_key === x.state).is_supported_by_selected_carriers),
        },
        isCarrierStateFilterDirty: true,
      }
    ));

  gotoPage = (targetPage) => {
    const { page } = this.state;
    if (isNavigationValid(page, targetPage, this.navigationStepValidators)) {
      if (this.prevCarrierIntegrations !== this.state.formData.carrier_integrations) {
        this.prevCarrierIntegrations = this.state.formData.carrier_integrations;
        this.updateSupportedStates();
      }
      this.setState({ page: targetPage });
    }
  };

  updateSupportedStates = async () => {
    this.props.showSpinner();
    this.setState({ supportedStates: null });
    const { shipment_states: supportedStates } = await API.getAvailableShipmentStates(
      this.state.formData.carrier_integrations.map(x => x.id),
    );

    this.setState((state) => {
      let { is_carrier_state_filter_enabled: isCarrierStateFilterEnabled } = state.formData;
      if (state.isCarrierStateFilterDirty) {
        if (state.formData.carrier_integrations.length === 0) {
          isCarrierStateFilterEnabled = false;
        }
      } else {
        isCarrierStateFilterEnabled = state.formData.carrier_integrations.length > 0;
      }

      return {
        supportedStates,
        formData: {
          ...state.formData,
          states: state.formData.states
            .filter(x => supportedStates.some(supportedState => supportedState.state_key === x.state
              && (!isCarrierStateFilterEnabled
                || supportedState.is_supported_by_selected_carriers))),
          is_carrier_state_filter_enabled: isCarrierStateFilterEnabled,
        },
      };
    }, () => {
      this.props.closeSpinner();
    });
  };

  updateState = (val, callback) => {
    this.setState(
      prevState => ({ formData: { ...prevState.formData, ...val } }),
      () => {
        if (typeof callback === 'function') callback();
        this.props.setSummaryData(this.state.formData);
      },
    );
  };

  smartFilterConfigExists = () => this.context.smartFilterConfiguration
    && (this.context.smartFilterConfiguration.group_by_metadata_key
      || this.context.smartFilterConfiguration.smart_filter_configuration_items.length > 0);

  submissionCompleted = () => {
    this.props.flipCard();
    this.gotoPage(0);
    this.setState({ formData: { ...this.initialState } });
    this.context.setShipmentFiltersUpdated(true);
  };

  submitForm = async () => {
    this.props.showSpinner();
    if (this.props.initialData) {
      await this.props.updateShipmentFilter(
        this.state.formData.id,
        this.state.formData,
        this.smartFilterConfigExists(),
        this.props.initialData.shipmentFilterExpiryMinutes != null,
      );
    } else {
      await this.props.createShipmentFilter(this.state.formData);
    }
    this.props.closeSpinner();
    this.submissionCompleted();
  };

  cancel = () => {
    this.setState({ formData: { ...this.initialState } });
    this.props.flipCard();
    this.gotoPage(0);
  };

  shipmentStatesStepValid() {
    return (this.state.formData.states && this.state.formData.states.length > 0)
    || (this.state.formData.calculated_events && this.state.formData.calculated_events.length > 0)
    || (this.state.formData.custom_event_types && this.state.formData.custom_event_types.length > 0);
  }

  render() {
    const { editMode } = this.props;
    const { customEventTypes } = this.context;

    return (
      <MultiPageForm
        page={this.state.page}
        goToPage={this.gotoPage}
        formPages={pageTabs => [
          <NameGroup
            title={shipmentFilterNameGroupTitle}
            pageTabs={pageTabs}
            gotoPage={this.gotoPage}
            updateState={this.updateState}
            cancel={this.cancel}
            formData={this.state.formData}
          />,
          <CarrierIntegrations
            title={shipmentFilterSelectIntegrationsTitle}
            pageTabs={pageTabs}
            gotoPage={this.gotoPage}
            updateState={this.updateState}
            cancel={this.cancel}
            formData={this.state.formData}
          />,
          <ShipmentStates
            title={shipmentFilterSelectStatesTitle}
            pageTabs={pageTabs}
            gotoPage={this.gotoPage}
            updateState={this.updateState}
            cancel={this.cancel}
            formData={this.state.formData}
            supportedStates={this.state.supportedStates}
            availableCustomEvents={customEventTypes}
            applyCarrierStateFilter={this.applyCarrierStateFilter}
            isValid={this.shipmentStatesStepValid()}
          />,
          <ShipmentType
            title={shipmentFilterShipmentTypeTitle}
            pageTabs={pageTabs}
            gotoPage={this.gotoPage}
            updateState={this.updateState}
            cancel={this.cancel}
            formData={this.state.formData}
          />,
          <ShipmentTags
            title={shipmentFilterShipmentTagsTitle}
            gotoPage={this.gotoPage}
            pageTabs={pageTabs}
            formData={this.state.formData}
            updateState={this.updateState}
            cancel={this.cancel}
          />,
          <ShipmentFilterExpiry
            title={shipmentFilterExpiryTitle}
            gotoPage={this.gotoPage}
            pageTabs={pageTabs}
            formData={this.state.formData}
            updateState={this.updateState}
            cancel={this.cancel}
          />,
          <RestrictTrigger
            title={shipmentFilterRestrictTriggerTitle}
            gotoPage={this.gotoPage}
            pageTabs={pageTabs}
            formData={this.state.formData}
            updateState={this.updateState}
            cancel={this.cancel}
          />,
          <SmartFilter
            title={shipmentFilterSmartFilterTitle}
            gotoPage={this.gotoPage}
            pageTabs={pageTabs}
            formData={this.state.formData}
            groupByMetadataKey={this.context.smartFilterConfiguration.group_by_metadata_key}
            updateState={this.updateState}
            cancel={this.cancel}
            submitForm={this.submitForm}
            editMode={editMode}
          />,
        ]}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  createShipmentFilter: shipmentFilter => dispatch(createShipmentFilter(shipmentFilter)),
  updateShipmentFilter: (
    id,
    shipmentFilter,
    smartFilterConfigurationExists,
    shipmentFilterExpiryExists,
  ) => dispatch(
    updateShipmentFilter(
      id,
      shipmentFilter,
      smartFilterConfigurationExists,
      shipmentFilterExpiryExists,
    ),
  ),
  showSpinner: () => dispatch(showSpinner()),
  closeSpinner: () => dispatch(closeSpinner()),
});

export default connect(null, mapDispatchToProps)(ShipmentFilterForm);
